export const MAX_QTY_PER_ITEM = 10;

export const FEATURED_GALLERY_IMAGES = [
  {
    src: 'https://i.imgur.com/9p1krlD.jpeg',
    alt: "Nature's Nefer moisturizer",
  },
  {
    src: 'https://i.imgur.com/Gx2xcKb.jpeg',
    alt: 'H.O.T Cocoa hot oil treatment',
  },
  {
    src: 'https://i.imgur.com/xDAZyOn.jpeg',
    alt: "Nature's Nefer shampoo",
  },
];

export const PRODUCT_GALLERY_IMAGES = [
  ...FEATURED_GALLERY_IMAGES,
  {
    src: '/images/hot-cocoa-ingredients.jpg',
    alt: 'H.O.T Cocoa ingredients and directions',
  },
];
